// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionSummaryReportPage_root__5hcA8"};